/**
 * BhanzuBot panel geometry, shared with the shell (components/Navbar), which
 * makes room for the open panel on wide screens.
 */

/** The open panel's width at sm and up, in px. */
export const PANEL_WIDTH = 380

/** The panel's distance from the screen's right and bottom edges at sm and up, in px. */
export const PANEL_EDGE = 24

/**
 * Right padding the page takes while the panel is open on a wide screen: the
 * panel, its edge gap, and the same gap again between page and panel. Without
 * it the panel covered the page's bottom-right controls (dev walkthrough,
 * 2026-10-20: the Pipelines paging bar's Next button sat under the panel).
 */
export const DOCKED_PAGE_PADDING = PANEL_WIDTH + 2 * PANEL_EDGE
